import parse from 'html-react-parser';
import { FC } from 'react';
import style from './linkDriveTermStyle.module.css';
import { RoundSheet } from '@/components/uiParts/Sheet/RoundSheet/RoundSheet';

interface LinkDriveTermProps {
  html?: string;
}
export const LinkDriveTerm: FC<LinkDriveTermProps> = ({ html }) => {
  if (!html) return <></>;
  return (
    <RoundSheet>
      <div className={style['container']}>{parse(html)}</div>
    </RoundSheet>
  );
};
